import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { motion } from "framer-motion";
import "./About.css";
import TopBar from "../../components/TopBar/TopBar";
import { client } from "../../client";
import PortableText from "react-portable-text";

// icons

import InstagramIcon from "@mui/icons-material/Instagram";
import GitHubIcon from "@mui/icons-material/GitHub";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Button from "../../components/Button/Button";
import EducationandAchivenment from "./Education";
import Education from "./Education";
import Achievement from "./Achievement";

const About = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "About - Shreeyash Parsawar | Portfolio";
  }, []);

  // api featch data

  const [aboutsection, setAboutsection] = useState([]);

  const [landingsection, setLandingsection] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "landingsection"]{
         
          "downloadcv": downloadcv.asset->url
            
        } `;

    client.fetch(query).then((data) => {
      setLandingsection(data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const query = `*[_type == "aboutsection"]{
            aboutdesc,
            sociallinkinstagram,
            sociallinkgithub,
            socialwhatsapplink,
            socialyoutubelink,
            aboutprofilephoto{
              asset->{
                  _id,
                  url
              }
          }
              
          } `;

    client.fetch(query).then((data) => {
      setAboutsection(data);
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionAbout pb-5">
          <TopBar />
          {aboutsection.length > 0 && (
            <div className="container-fluid">
              <div className="row">
                {/* heading text  */}
                <div className="col-lg-12">
                  <div className="wrapper">
                    <svg>
                      <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                        Who I Am ?
                      </text>
                    </svg>
                  </div>
                </div>
                {/* heading text  */}

                {/* ----------------------------------------------------------------------------- */}

                {/* About Seciton  */}

                <div className="col-lg-6 text-center ">
                  <img
                    src={aboutsection[0].aboutprofilephoto.asset.url}
                    className="img-fluid card-img-top"
                    alt=""
                    style={{ width: "600px" }}
                  />

                  <div className="mt-3">
                    <h1 className="follow_heding">Connect with me</h1>
                    <a
                      style={{ color: "white" }}
                      href={aboutsection[0].sociallinkinstagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InstagramIcon
                        className="zoomicon"
                        sx={{ fontSize: 40 }}
                      />
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a
                      style={{ color: "white" }}
                      href={aboutsection[0].sociallinkgithub}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <GitHubIcon className="zoomicon" sx={{ fontSize: 40 }} />
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a
                      style={{ color: "white" }}
                      href={aboutsection[0].socialwhatsapplink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <WhatsAppIcon
                        className="zoomicon"
                        sx={{ fontSize: 40 }}
                      />
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a
                      style={{ color: "white" }}
                      href={aboutsection[0].socialyoutubelink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <YouTubeIcon className="zoomicon" sx={{ fontSize: 40 }} />
                    </a>
                    &nbsp;&nbsp;&nbsp;
                  </div>

                  <div className="mt-3">
                    {landingsection.length > 0 && (
                      <div className="col-lg-12 text-center">
                        <a
                          href={`${landingsection[0].downloadcv}?dl=Shreeyash_Parsawar_Resume.pdf`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button title="Get A Resume" />
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 text-capitalize d-flex align-items-center ">
                  <PortableText
                    content={aboutsection[0].aboutdesc}
                    className="paraText aboutpara"
                  />
                </div>

                {/* About Seciton  */}

                {/* ----------------------------------------------------------------------------- */}

                {/* Education and Achivenment section  */}

                <div className="container mt-5 pt-5">
                  <div className="row">
                    <div className="col-lg-6 border-right">
                      <h1 className="text-left subHeading">Education </h1>

                      <Education />
                    </div>

                    <div className="col-lg-6 ">
                      <h1 className="text-left subHeading">Achievements</h1>

                      <Achievement />
                    </div>
                  </div>
                </div>

                {/* Education and Achivenment section  */}

                {/* ----------------------------------------------------------------------------- */}
              </div>
            </div>
          )}

          {/* <Navbar /> */}
        </section>
      )}
    </motion.div>
  );
};

export default About;
